import type { PaginatedResponse, PaginationMeta } from '@models/pagination'
import type {
  VehicleProfileFilters,
  VehicleProfile,
} from '@models/vehicleProfile'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import vehicleProfilesApi from './actions'
import { vehicleProfilesKeys } from './constants'

export interface UseVehicleProfilesData {
  vehicleProfiles: VehicleProfile[]
  vehicleProfilesMap: Map<number, VehicleProfile>
  pagination: PaginationMeta
}

const selectData = ({
  data,
  pagination,
}: PaginatedResponse<VehicleProfile>): UseVehicleProfilesData => ({
  vehicleProfiles: data,
  vehicleProfilesMap: new Map(data.map(profile => [profile.id, profile])),
  pagination,
})

const useVehicleProfiles = (filters: VehicleProfileFilters) => {
  const query = useQuery<
    PaginatedResponse<VehicleProfile>,
    AxiosError,
    UseVehicleProfilesData
  >(
    vehicleProfilesKeys.list(filters),
    () => vehicleProfilesApi.getVehicleProfiles(filters),
    {
      select: selectData,
      enabled: !!filters.companyId,
    },
  )
  return query
}

export default useVehicleProfiles
